import React from 'react';
import {Redirect} from 'react-router';

const NotFoundComponent = () => <Redirect to={'/not-found'} />;

export default NotFoundComponent;
